<template>
  <article>
   <div class="filter mt-20 mb-20">
      <div class="ml-auto">
        <button class="blue-small-btn" @click="detailDialog = !detailDialog">新建</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700">
      <el-table-column prop="bid" label="分类ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="title" label="标题" width="" align="center">
      </el-table-column>
      <el-table-column prop="weight" label="权重" width="" align="center">
      </el-table-column>
      <el-table-column prop="icon" label="icon图">
        <template slot-scope="scope">
          <div class="mt10">
            <img :src="scope.row.icon" height="60px" weight="60px" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="display" label="是否展示" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.display == 1" class="normal-btn">显示</div>
          <div v-if="scope.row.display == 0" class="danger-btn">隐藏</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn" @click="editDetail(scope.$index)">编辑</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="banner图编辑" :visible.sync="detailDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">账单ID</div>
            <el-input v-model="detail.bid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">分类名</div>
            <el-input v-model="detail.title" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">权重</div>
            <el-input v-model="detail.weight" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">icon图:</div>
            <uploadHeadImage :url.sync="detail.icon" :itype="5"></uploadHeadImage>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="detail.display">
              <div class="dib mr-20">
                <el-radio :label="0">隐藏</el-radio>
                <el-radio :label="1">运行</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="shopBannerEdit">保存</div>
          <div class="gray-large-btn" @click="detailDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>
<script>
import util from '../../../script/util'
import {shopBannerLists, shopBannerEdit} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'shopBanner',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      lists: [],
      listLoading: false,
      detailDialog: false,
      detail: {
        bid: 0,
        title: '',
        icon: '',
        weight: 0,
        display: 1
      }
    }
  },
  methods: {
    editDetail (index) {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = this.lists[index][key]
      }
    },
    shopBannerEdit () {
      let params = {
        bid: this.detail.bid,
        title: this.detail.title,
        icon: this.detail.icon,
        weight: this.detail.weight,
        display: this.detail.display
      }

      shopBannerEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.detailDialog = false
          this.getList()

          for (let key in this.detail) {
            this.detail[key] = ''
          }
          this.detail.bid = 0
          this.detail.weight = 0
          this.detail.display = 1
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let params = {
      }

      this.listLoading = true
      shopBannerLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopBanner.vue